import styled from "@emotion/styled";

export const WaveformWrap = styled.div`
  position: relative;
  flex: 1;
  height: 24px;
  display: flex;
  align-items: center;
  overflow: hidden;
  touch-action: none; /* important for drag seeking on mobile */
  overflow: visible;
`;
